var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSanctionedTermsError = function SvgSanctionedTermsError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21 13V6C21 3.79086 19.2091 2 17 2H7C4.79086 2 3 3.79086 3 6V18C3 20.2091 4.79086 22 7 22H13",
    stroke: "#CF1322",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H14",
    stroke: "#CF1322",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H16",
    stroke: "#CF1322",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H11",
    stroke: "#CF1322",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2052 22.2659C21.4981 22.5588 21.973 22.5588 22.2659 22.2659C22.5588 21.973 22.5588 21.4981 22.2659 21.2052L20.258 19.1973L22.2659 17.1894C22.5588 16.8965 22.5588 16.4217 22.2659 16.1288C21.973 15.8359 21.4981 15.8359 21.2052 16.1288L19.1973 18.1367L17.1885 16.1279C16.8956 15.835 16.4208 15.835 16.1279 16.1279C15.835 16.4208 15.835 16.8956 16.1279 17.1885L18.1367 19.1973L16.1279 21.2061C15.835 21.499 15.835 21.9739 16.1279 22.2668C16.4208 22.5597 16.8956 22.5597 17.1885 22.2668L19.1973 20.258L21.2052 22.2659Z",
    fill: "#CF1322"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSanctionedTermsError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sanctioned-terms-error.3ebab1a53eabd0948de2bb7926a9b8fb.svg";